angular.module('rjmNg.api').factory("userService", [
  "$resource"
  "phpServiceUrl"
  "app"
  ($resource, phpServiceUrl, app) ->

    actions =
      save:
        method: 'POST'
      query:
        method: 'GET'
        isArray: true
      get:
        method: 'GET'
        url: phpServiceUrl("/client/#{app.getClientId()}/user/:id")
        isArray: true
      update:
        method: 'POST'
        url: phpServiceUrl("/client/#{app.getClientId()}/user/:id")
      stores:
        method: 'GET'
        isArray: false
      emails:
        method: 'GET'
        isArray: false

    manageUsersStoreService = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups-list"), {}, actions)
    userService = $resource(phpServiceUrl("/client/#{app.getClientId()}/user/"), {}, actions)
    accessGroupEmail = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups/:groupId/emails/"), { groupId: '@groupId' }, actions)

    {
      save: (user) ->
        userService.save({}, user).$promise
      query: (clientId) ->
        userService.query({}, clientId).$promise
      update: (user) ->
        userService.update({id: user.id}, user).$promise
      get: (userId) ->
        userService.get({id: userId}).$promise
      stores: (clientId) ->
        manageUsersStoreService.stores({}, clientId).$promise
      emails: (groupData, user) ->
        userEmail = groupData.groupId;
        accessGroupEmail.emails({ groupId: userEmail }, user).$promise  
    }
  ]
)
